module.exports = __webpack_public_path__ + "static/bright-cellars-badge-logo-501286a45f97d8c028a2f023d7dccde2.png";